import { useCallback } from 'react'
import React from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { ICheckboxProps, CheckboxValue } from 'components/uiKit/Checkbox'
import Checkbox from 'components/uiKit/Checkbox'

const FieldCheckbox = <V extends CheckboxValue>({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<ICheckboxProps<V>, V>) => {
  const handleChange = useCallback((value: V) => onChange({ name, value }), [name, onChange])

  return <Checkbox {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldCheckbox) as typeof FieldCheckbox
